<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8"/>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <LeaguesTable title="Leagues" :data="tableData"></LeaguesTable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import LeaguesTable from '@/views/Leagues/Tables/LeaguesTable.vue';
import ErrorHandler from '@/helpers/AuthError';

export default {
  components: {
    LeaguesTable,
  },
  data() {
    return {
      tableData: [
        {
          name: '1 The North Swing Cup Fall 2019',
          type: 'Flex',
          weeks: 12,
          currentWeek: 2,
          public: true,
          players: 14,
        },
      ],
    };
  },
  mounted() {
    this.getLeagues();
  },
  methods: {
    getLeagues() {
      this.axios
        .get('/leagues', {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          const cleanLeagues = [];
          response.data.forEach((league) => {
            const newLeague = {};
            newLeague.id = league.id;
            newLeague.name = league.Name;
            newLeague.type = league.type;
            newLeague.public = league.public;
            newLeague.players = league.profiles.length > 0 ? league.profiles.length : league.teams.length;
            newLeague.weeks = league.weeks.length;

            // get current week
            const curWeek = this.getCurrentWeek(league.weeks);
            newLeague.currentWeek = curWeek !== null ? `Week ${curWeek.WeekNumber}` : 'Not Open';

            cleanLeagues.push(newLeague);
          });

          this.tableData = cleanLeagues;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    getCurrentWeek(weeks) {
      let curWeek = null;
      weeks.forEach((week) => {
        if (
          moment(week.Start).isBefore(moment())
          && moment(week.Start).add(7, 'days').isAfter(moment())
        ) {
          curWeek = week;
        }
      });
      return curWeek;
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
